<template>
  <table class="table table-sm wtt">
    <thead>
      <tr>
        <th>Название работы</th>
        <th>Материалы и количество</th>
        <th class="wtt__num">Расходники</th>
        <th class="wtt__num">Работы без расходников</th>
        <th class="wtt__num">Расчётный итог</th>
        <th class="wtt__actions">Действия</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="rows.length === 0">
        <td colspan="6" class="text-muted text-center py-3">Записей нет</td>
      </tr>
      <tr v-for="row in rows" :key="row.id" class="wtt__row" :class="{ 'wtt__row--archived': archived(row) }">
        <td class="wtt__title">{{ row.title }}<span v-if="archived(row)" class="wtt__tag">архив</span></td>
        <td>
          <div v-for="c in consumablesOf(row)" :key="c.id" class="wtt__mat">{{ line(c) }}<span v-if="archived(c)" class="wtt__tag">архив</span></div>
          <span v-if="consumablesOf(row).length === 0" class="text-muted">Без расходников</span>
        </td>
        <td class="wtt__num">
          {{ rub(money(row).consumablesTotal) }}
          <div v-if="money(row).incomplete" class="wtt__hint">не все цены заданы</div>
        </td>
        <td class="wtt__num">{{ rub(money(row).workPrice) }}</td>
        <td class="wtt__num wtt__total">
          {{ rub(money(row).total) }}
          <div v-if="money(row).incomplete" class="wtt__hint">не все цены заданы</div>
        </td>
        <td class="wtt__actions">
          <button type="button" class="btn btn-sm btn-outline-secondary wtt__edit" :disabled="locked(row)" @click="$emit('edit', row)">Изменить</button>
          <button v-if="archived(row)" type="button" class="btn btn-sm btn-outline-secondary wtt__unarchive" :disabled="locked(row)" @click="$emit('unarchive', row)">Вернуть</button>
          <button v-else type="button" class="btn btn-sm btn-outline-secondary wtt__archive" :disabled="locked(row)" @click="$emit('archive', row)">В архив</button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { isArchived, formatRub, formatQuantityLine, workTypeMoney } from '@/components/management/dispatcher/catalogPayload';

export default {
  name: 'WorkTypesTable',
  props: {
    rows: { type: Array, default: () => [] },
    pendingIds: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    archived: (row) => isArchived(row),
    rub: (n) => formatRub(n),
    line: (c) => formatQuantityLine(c),
    money: (row) => workTypeMoney(row),
    consumablesOf: (row) => (Array.isArray(row.consumables) ? row.consumables : []),
    locked(row) { return this.disabled || this.pendingIds.includes(row.id); },
  },
};
</script>

<style scoped lang="scss">
.wtt { margin-bottom: 0; font-size: 13px; }
.wtt th { font-size: 10.5px; letter-spacing: .08em; text-transform: uppercase; color: #9aa09b; border-top: 0; white-space: nowrap; }
.wtt td { vertical-align: top; }
.wtt__title { font-weight: 600; }
.wtt__mat { color: #4c524d; font-size: 12.5px; line-height: 1.5; }
.wtt__num { text-align: right; white-space: nowrap; }
.wtt__total { font-weight: 700; }
.wtt__hint { font-size: 11px; color: #8b918c; font-weight: 400; }
.wtt__actions { text-align: right; white-space: nowrap; width: 1%; button + button { margin-left: 6px; } }
.wtt__row--archived td { color: #8b918c; }
.wtt__tag { display: inline-block; margin-left: 8px; padding: 1px 6px; border-radius: 6px; background: #f4f5f1; color: #8b918c; font-size: 10.5px; text-transform: uppercase; letter-spacing: .06em; }
</style>
